import LanguageIcon from '@mui/icons-material/Language';

import * as React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks';
import { HK, CN, GB } from 'country-flag-icons/react/3x2';
import { SupportedLanguages } from '@/i18n';

type Props = {
    onChange?: (lang: SupportedLanguages) => void;
    anchorComponent?: (props: object) => React.ReactNode;
};

const LanguageSelector: React.FC<Props> = ({ onChange, anchorComponent }) => {
    const popupState = usePopupState({ variant: 'popover', popupId: 'languageMenu' });

    const onSelected = (lang: SupportedLanguages) => {
        if (onChange) {
            onChange(lang);
        }
        popupState.close();
    };

    return (
        <div>
            {anchorComponent ? (
                anchorComponent(bindTrigger(popupState))
            ) : (
                <IconButton {...bindTrigger(popupState)}>
                    <LanguageIcon />
                </IconButton>
            )}
            <Menu
                {...bindMenu(popupState)}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
            >
                <MenuItem onClick={() => onSelected('zh-HK')}>
                    <Stack direction='row' gap={1}>
                        <HK width={24}></HK>
                        <Typography>繁體中文</Typography>
                    </Stack>
                </MenuItem>
                <MenuItem onClick={() => onSelected('zh-CN')}>
                    <Stack direction='row' gap={1}>
                        <CN width={24}></CN>
                        <Typography>简体中文</Typography>
                    </Stack>
                </MenuItem>
                <MenuItem onClick={() => onSelected('en')}>
                    <Stack direction='row' gap={1}>
                        <GB width={24}></GB>
                        <Typography>English</Typography>
                    </Stack>
                </MenuItem>
            </Menu>
        </div>
    );
};

export default LanguageSelector;
